module.exports = __webpack_public_path__ + "images/handwritten-10419d8812dc3555f0e823cde93ad6da.jpg";